'use client';

var __jsx = React.createElement;
import React from 'react';
import useMuscleRouter from '@lib/hooks/use-muscle-router';
import PlatformLogo from '@modules/shared/logos/platform-logo';
import APP_CONFIGURATION from '@lib/app.config';
import { useCustomer } from '@lib/context/shared/customer-context';
import useCssModules from '@lib/hooks/use-css-modules';
import PlatformIcon from '@modules/shared/logos/platform-icon';
const HeaderEntityLogo = _ref => {
  let {
    onClick
  } = _ref;
  const router = useMuscleRouter();
  const {
    customerIsLogged,
    allowUnauthenticatedCustomer
  } = useCustomer();
  const isMaintenance = process.env.NEXT_PUBLIC_SHOW_LANDING_MAINTENANCE === "true";
  const {
    cssModules
  } = useCssModules();
  const {
    headerEntityContainerLogoClassNames,
    headerEntityLogoDesktopClassNames,
    headerEntityLogoMobileClassNames
  } = (cssModules === null || cssModules === void 0 ? void 0 : cssModules.account.header) || {};
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    if (customerIsLogged || allowUnauthenticatedCustomer) {
      router.push('/' + (localStorage.getItem('current-app') !== null ? localStorage.getItem('current-app') : ''));
    } else {
      router.push('/');
    }
  };
  return __jsx(React.Fragment, null, isMaintenance ? __jsx("div", {
    className: "header-element min-w-[213px] w-fit  lg:-translate-x-7"
  }, __jsx(PlatformLogo, {
    height: APP_CONFIGURATION.config.appLogoHeight,
    dataTestId: "header-entity-logo"
  })) : __jsx(React.Fragment, null, __jsx("div", {
    className: headerEntityLogoDesktopClassNames,
    onClick: handleClick
  }, __jsx(PlatformLogo, {
    className: headerEntityLogoDesktopClassNames,
    dataTestId: "header-entity-logo"
  })), __jsx("div", {
    className: "md:hidden",
    onClick: handleClick
  }, __jsx(PlatformIcon, {
    className: headerEntityLogoMobileClassNames,
    dataTestId: "header-entity-logo-mobile"
  }))));
};
export default HeaderEntityLogo;